export class StoreModel {
    id = 0;
    publicId = '';
    name = '';
    billingAddress = '';
    application = '';
    cashboxes = '';
    chainID = '';
    changedEvaluatedCategory = false;
    city = '';
    displayInStoreDto = {
        count: '',
        displayCode: '',
        displayID: null,
        displayOnExtraPosition: false,
        displayPosition: '',
        displayPositionID: null,
        extraPosition: false,
        storeID: '',
    };
    displayPositionID = '';
    evaluatedCategory: '' = '';
    hasLocation = false;
    lastVisited = '';
    lastVisitedBy = '';
    latitude = undefined;
    longitude = undefined;
    manager = '';
    notes = '';
    numberOfVisitsInLastYear = '';
    phone = '';
    photo = '';
    pib = '';
    positionRateSettings = {
        storeTypeID: '',
        selected: []
    };
    responsible = '';
    route = '';
    salesPersonID = '';
    secondaryPosition = '';
    secondaryPositionPhoto = 'assets/images/image.png';
    shippingAddress = '';
    state = '';
    storeCategorization = {
        categorization1Id: '',
        categorization2Id: '',
        categorization3Id: '',
        categorization4Id: '',
        categorization5Id: '',
        categorization6Id: '',
        categorization7Id: '',
        categorization8Id: '',
        categorization9Id: '',
    };
    storeCategoryId = '';
    storeRate = '';
    storeRateSample = '';
    storeType = '';
    storeTypeId = '';
    supplierId = '';
    turnover = '';
    zipCode = '';
    migrationId = null;
}
